<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `transaction/academic-new-group/${inputs.id}`
            : `transaction/academic-new-group`
        "
      >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_course_id" class="col-sm-3 mb-0">
                Class Name
              </label>
              <app-input
                id="inputs_course_id"
                type="advance-search-select"
                :loaded-per-time="10"
                v-model="input_course_id"
                fetch-url="transaction/course"
                class="col-sm-9"
                placeholder="Class Name"
                list-value-field="course_name"
                required
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_course_group_id" class="col-sm-3 mb-0">
                Group Class
              </label>
              <app-input
                id="inputs_course_group_id"
                type="advance-search-select"
                :loaded-per-time="10"
                v-model="input_course_group_id"
                fetch-url="transaction/course-group"
                class="col-sm-9"
                placeholder="Group Class"
                list-value-field="course_group_name"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_course_type_id" class="col-sm-3 mb-0">
                Class Type
              </label>
              <app-input
                id="inputs_course_type_id"
                type="advance-search-select"
                :loaded-per-time="10"
                v-model="input_course_type_id"
                fetch-url="master/course-type"
                class="col-sm-9"
                placeholder="Class Type"
                list-value-field="course_type_name"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_center_id" class="col-sm-3 mb-0">
                CLC Centre
              </label>
              <app-input
                id="inputs_center_id"
                type="advance-search-select"
                :loaded-per-time="10"
                v-model="input_center_id"
                fetch-url="master/center"
                class="col-sm-9"
                placeholder="CLC Centre"
                list-value-field="name"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_main_teach_id" class="col-sm-3 mb-0">
                Main Teacher
              </label>
              <app-input
                id="inputs_main_teach_id"
                class="col-sm-9"
                type="search-select"
                :list="teachIdLists"
                v-model="inputs.main_teach_id"
                :placeholder="'Main Teacher'"
                :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_teacher_trainer_id" class="col-sm-3 mb-0">
                Teacher Trainer
              </label>
              <app-input
                id="inputs_teacher_trainer_id"
                type="advance-search-select"
                :loaded-per-time="10"
                v-model="input_teacher_trainer_id"
                fetch-url="user-list"
                class="col-sm-9"
                placeholder="Teacher Trainer"
                list-value-field="full_name"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_student_care_id_1" class="col-sm-3 mb-0">
                Student Care #1
              </label>
              <app-input
                id="inputs_student_care_id_1"
                class="col-sm-9"
                type="search-select"
                :list="studentCareIdLists"
                v-model="inputs.student_care_id_1"
                :placeholder="'Student Care #1'"
                :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_student_care_id_2" class="col-sm-3 mb-0">
                Student Care #2
              </label>
              <app-input
                id="inputs_student_care_id_2"
                class="col-sm-9"
                type="search-select"
                :list="studentCareIdLists"
                v-model="inputs.student_care_id_2"
                :placeholder="'Student Care #2'"
                :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_co_teacher_id" class="col-sm-3 mb-0">
                CO Teacher
              </label>
              <app-input
                id="inputs_co_teacher_id"
                type="advance-search-select"
                :loaded-per-time="10"
                v-model="input_co_teacher_id"
                fetch-url="user-list"
                class="col-sm-9"
                placeholder="CO Teacher"
                list-value-field="full_name"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_sc_supervisor_id" class="col-sm-3 mb-0">
                SC Supervisor
              </label>
              <app-input
                id="inputs_sc_supervisor_id"
                type="advance-search-select"
                :loaded-per-time="10"
                v-model="input_sc_supervisor_id"
                fetch-url="user-list"
                class="col-sm-9"
                placeholder="SC Supervisor"
                list-value-field="full_name"
                required
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_start_date" class="col-sm-3 mb-0">
                Start Date
              </label>
              <app-input
                id="inputs_start_date"
                type="date"
                v-model="inputs.start_date"
                class="col-sm-9"
                placeholder="Start Date"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_end_date" class="col-sm-3 mb-0">
                End Date
              </label>
              <app-input
                id="inputs_end_date"
                type="date"
                v-model="inputs.end_date"
                class="col-sm-9"
                placeholder="End Date"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_start_week" class="col-sm-3 mb-0">
                Start Week
              </label>
              <app-input
                id="inputs_start_week"
                type="text"
                v-model="inputs.start_week"
                class="col-sm-9"
                placeholder="Start Week"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_end_week" class="col-sm-3 mb-0">
                End Week
              </label>
              <app-input
                id="inputs_end_week"
                type="text"
                v-model="inputs.end_week"
                class="col-sm-9"
                placeholder="End Week"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row align-items-center">
              <label for="inputs_last_modified" class="col-sm-3 mb-0">
                Last Modified
              </label>
              <app-input
                id="inputs_last_modified"
                class="col-sm-9"
                type="text"
                v-model="inputs.updated_at"
                placeholder="Last Modified"
                :disabled="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { GroupFindListFormMixin } from "./GroupFindListFormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
  name: "GroupFindListForm",
  mixins: [GroupFindListFormMixin, ModalMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {
          code: "",
          name: "",
          is_active: "",
        };
      },
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      input_course_id: this.value
        ? this.value.course
          ? {
              id: this.value.course.id || 0,
              course_name: this.value.course.course_name || "",
              is_active: this.value.course.is_active,
            }
          : {
              id: this.value.course?.id || 0,
              course_name: this.value.course?.course_name || "",
              is_active: this.value.course?.is_active,
            }
        : {
            id: this.value.course.id || 0,
            course_name: this.value.course.course_name || "",
            is_active: this.value.course.is_active,
          },
      input_course_group_id: this.value
        ? this.value.course_group
          ? {
              id: this.value.course_group.id || 0,
              course_group_name: this.value.course_group.course_group_name || "",
              is_active: this.value.course_group.is_active,
            }
          : {
              id: this.value.course_group?.id || 0,
              course_group_name: this.value.course_group?.course_group_name || "",
              is_active: this.value.course_group?.is_active,
            }
        : {
            id: this.value.course_group.id || 0,
            course_group_name: this.value.course_group.course_group_name || "",
            is_active: this.value.course_group.is_active,
          },
      input_course_type_id: this.value
        ? this.value.course_type
          ? {
              id: this.value.course_type.id || 0,
              course_type_name: this.value.course_type.course_type_name || "",
              is_active: this.value.course_type.is_active,
            }
          : {
              id: this.value.course_type?.id || 0,
              course_type_name: this.value.course_type?.course_type_name || "",
              is_active: this.value.course_type?.is_active,
            }
        : {
            id: this.value.course_type.id || 0,
            course_type_name: this.value.course_type.course_type_name || "",
            is_active: this.value.course_type.is_active,
          },
      input_center_id: this.value
        ? this.value.center
          ? {
              id: this.value.center.id || 0,
              name: this.value.center.name || "",
              is_active: this.value.center.is_active,
            }
          : {
              id: this.value.center?.id || 0,
              name: this.value.center?.name || "",
              is_active: this.value.center?.is_active,
            }
        : {
            id: this.value.center.id || 0,
            name: this.value.center.name || "",
            is_active: this.value.center.is_active,
          },
      input_teacher_trainer_id: this.value?.teacher_trainer
        ? {
            id: this.value.teacher_trainer.id || 0,
            name: this.value.teacher_trainer.full_name || "",
            is_active: this.value.teacher_trainer.is_active,
          }
        : {
            id: 0,
            name: "",
            is_active: true,
          },

      input_co_teacher_id: this.value?.co_teacher
        ? {
            id: this.value.co_teacher.id || 0,
            name: this.value.co_teacher.full_name || "",
            is_active: this.value.co_teacher.is_active,
          }
        : {
            id: 0,
            name: "",
            is_active: true,
          },

      input_sc_supervisor_id: this.value?.sc_supervisor
        ? {
            id: this.value.sc_supervisor.id || 0,
            name: this.value.sc_supervisor.full_name || "",
            is_active: this.value.sc_supervisor.is_active,
          }
        : {
            id: 0,
            name: "",
            is_active: true,
          },
      modalId: this.formId,
      modalTitle: this.$t("add"),
      clcCentreList: [],
      subStatusLists: [],
      studentCareIdLists: [],
      teachIdLists: [],
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }

    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        if (this.selectedUrl) {
          this.modalTitle = this.$t("edit");
          this.preloader = true;
        }

        let [userResponse, centerResponse, leadStatusResponse] =
          await Promise.all([
            axios.get("/user-list?per_page=50"),
            axios.get("/master/center?is_active=true&per_page=50"),
            axios.get("/master/lead-status?lead_status_id=3&per_page=50"),
          ]);

        userResponse.data.data.forEach((item) => {
          this.studentCareIdLists.push({
            id: item.id,
            value: item.full_name,
          });

          this.teachIdLists.push({
            id: item.id,
            value: item.full_name,
          });
        });

        centerResponse.data.data.forEach((item) => {
          this.clcCentreList.push({
            id: item.id,
            value: item.name,
          });
        });

        this.subStatusLists = leadStatusResponse.data.data.map((item) => ({
          id: item.id,
          value: item.status,
        }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    submit() {
      if (!this.validateForm()) return;
      
      const payload = {
        course_id: this.input_course_id.id,
        course_group_id: this.input_course_group_id.id,
        course_type_id: this.input_course_type_id.id,
        center_id: this.input_center_id.id,
        main_teacher_id: this.inputs.main_teach_id,
        trainer_teacher_id: this.input_teacher_trainer_id.id,
        student_care_id_1: this.inputs.student_care_id_1,
        student_care_id_2: this.inputs.student_care_id_2,
        co_teacher_id: this.input_co_teacher_id.id,
        sc_supervisor_id: this.input_sc_supervisor_id.id,
        start_date: this.inputs.start_date.toISOString().split('T')[0],
        end_date: this.inputs.end_date.toISOString().split('T')[0],
        start_week: this.inputs.start_week,
        end_week: this.inputs.end_week,
      };

      const url = this.selectedUrl
        ? `academic-new-group/${this.inputs.id}`
        : `academic-new-group`;

      const method = this.selectedUrl ? "put" : "post";

      this.preloader = true;

      axios[method](url, payload)
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.$hub.$emit("reload-" + this.tableId);
          this.closeModal();
        })
        .catch((err) => {
          this.$toastr.e("Error: " + err.response?.data?.message || err.message);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    validateForm() {
      // Contoh validasi sederhana
      if (!this.input_course_id || !this.input_course_id.id) {
        this.$toastr.e("Class Name is required");
        return false;
      }
      if (!this.input_course_group_id || !this.input_course_group_id.id) {
        this.$toastr.e("Group Class is required");
        return false;
      }

      if (!this.input_course_type_id || !this.input_course_type_id.id) {
        this.$toastr.e("Class Type is required");
        return false;
      }

      if (!this.input_center_id || !this.input_center_id.id) {
        this.$toastr.e("CLC Centre is required");
        return false;
      }

      if (!this.inputs.main_teach_id) {
        this.$toastr.e("Main Teacher is required");
        return false;
      }

      if (!this.input_teacher_trainer_id || !this.input_teacher_trainer_id.id) {
        this.$toastr.e("Trainer Teacher is required");
        return false;
      }

      if (!this.inputs.student_care_id_1) {
        this.$toastr.e("Student Care #1 is required");
        return false;
      }

      if (!this.inputs.student_care_id_2) {
        this.$toastr.e("Student Care #2 is required");
        return false;
      }

      if (!this.input_co_teacher_id || !this.input_co_teacher_id.id) {
        this.$toastr.e("Co Teacher is required");
        return false;
      }
      if (!this.input_sc_supervisor_id || !this.input_sc_supervisor_id.id) {
        this.$toastr.e("SC Supervisor is required");
        return false;
      }

      if (!this.inputs.start_date) {
        this.$toastr.e("Start Date is required");
        return false;
      }


      if (!this.inputs.end_date) {
        this.$toastr.e("End Date is required");
        return false;
      }

      if (!this.inputs.start_week) {
        this.$toastr.e("Start Week is required");
        return false;
      }

      if (!this.inputs.end_week) {
        this.$toastr.e("End Week is required");
        return false;
      }

      return true;
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>
<style scoped>
::v-deep(.modal-dialog) {
  min-width: 1000px !important;
}
</style>